import React, { useMemo, useState, Fragment } from 'react'
import { Table, Input, Modal } from 'antd'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import { NPersonal, EGetUserCollect, EPostCollectInfo } from '../../../../models/constants'
import { effect, useStore } from '../../../../dva16'
import './index.less'

export default function CollectionInfo() {
  const { confirm } = Modal
  const [changePage, setChangePage] = useState(1)
  const { myCollect } = useStore(NPersonal)

  useMemo(() => {
    effect(NPersonal, EGetUserCollect)
  }, [])

  const showDeleteConfirm = (item) => {
    confirm({
      title: `确认取消收藏【${item.info && item.info.title}】`,
      icon: <ExclamationCircleOutlined />,
      content: '一旦取消收藏，不可撤回',
      okText: '确认',
      okType: 'danger',
      cancelText: '取消',
      onOk() {
        effect(NPersonal, EPostCollectInfo, { id: item.infoID, page: changePage })
      },
    })
  }

  const handleKeyUp = (e) => {
    if (e.keyCode === 13) {
      effect(NPersonal, EGetUserCollect, { search: e.target.value })
    }
  }
  const TableColumns = [
    {
      title: '帖子',
      dataIndex: 'info',
      width: 250,
      key: 'info',
      render: (text, item) =>
        text.topic ? (
          <span
            style={{ cursor: 'pointer' }}
            onClick={() => {
              window.location.href = `#/detail/${text.id}`
            }}
          >{`[${text.topic.name}]${text.title}`}</span>
        ) : (
          <span
            style={{ cursor: 'pointer' }}
            onClick={() => {
              window.location.href = `#/detail/${text.id}`
            }}
          >
            {text.title}
          </span>
        ),
    },
    {
      title: '板块',
      dataIndex: 'info',
      key: 'info',
      render: (text, item) => <span>{text.type}</span>,
    },
    {
      title: '收藏时间',
      dataIndex: 'createdAt',
      key: 'createdAt',
    },
    {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
      render: (text, item) => <span onClick={() => showDeleteConfirm(item)}>取消收藏</span>,
    },
  ]

  return (
    <div id="MyInfo">
      <div className="myinfo-title">
        <div className="title-lfet">
          <span>我的收藏</span>
          <Input onKeyUp={(e) => handleKeyUp(e)} placeholder="搜索帖子" />
        </div>
        <div className="title-right">
          <span>
            共有<i>{myCollect.total}</i>个帖子
          </span>
        </div>
      </div>
      <Table
        rowKey={(record) => record.id}
        onChange={(pagination, filters, sorter, extra) => {
          setChangePage(pagination.current)
          effect(NPersonal, EGetUserCollect, { page: pagination.current })
        }}
        pagination={{ total: myCollect.total }}
        columns={TableColumns}
        dataSource={myCollect.data}
      />
    </div>
  )
}
